import { render } from "./VesselPositions.vue?vue&type=template&id=0f40a246&scoped=true"
import script from "./VesselPositions.vue?vue&type=script&lang=js"
export * from "./VesselPositions.vue?vue&type=script&lang=js"

import "./VesselPositions.vue?vue&type=style&index=0&id=0f40a246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f40a246"]])

export default __exports__